import AnnouncementBar from "../components/layout/AnnouncementBar";
import Navbar from "../components/layout/Navbar";
import Hero from "../components/Hero";
import Categories from "../components/Home/Categories";
import FeaturedCollection from "../components/ui/FeaturedCollection";
import BestSellers from "../components/Home/BestSellers";
import LifestyleBanner from "../components/Home/LifestyleBanner";
import CoffeeSection from "../components/Home/CoffeeSection";
import Newsletter from "../components/Home/Newsletter";
// import Footer from "../components/Home/Footer";

export default function Home() {
  return (
    <main className="bg-[#FAFCF9] text-[#1F2937] overflow-x-hidden">
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <Categories/>
      <FeaturedCollection/>
      <BestSellers/>
      <LifestyleBanner/>
      <CoffeeSection/>
      <Newsletter/>
      {/* <Footer/> */}
      
      
    </main>
  );
}